import {
  ORDER_DEPRECIATION_SETTINGS_V2_API,
  TKV2_ORDER_DEPRECIATION_SETTINGS_API,
} from '@aloft/toolkit-shared';

import { useEffect } from 'react';

import { usePutOrderDepreciationSettingsV2API } from '../../hooks/api/toolkitComponents.ts';
import { useEdgeTrigger } from '../../hooks/useEdgeTrigger.ts';
import { depreciationSettingsMutationComplete } from '../../redux/features/orderSlice.ts';
import { useAppDispatch, useAppSelector } from '../../redux/hooks.ts';
import { DEFAULT_SYNC_DRIVER_DELAY_MS } from './consts.ts';

export function useDepreciationSettingsSyncDriver(orderID: string) {
  const dispatch = useAppDispatch();
  const { mutate: depreciationSettingsMutate } = usePutOrderDepreciationSettingsV2API();
  const depreciationSettings = useAppSelector((state) => state.order.depreciationSettings);
  const {
    editRevision = 0,
    serverRevision = 0,
    saveAsDefault,
  } = useAppSelector((state) => state.order.depreciationSettingsSync) ?? {};

  const onSuccess = () => {
    dispatch(
      depreciationSettingsMutationComplete({
        status: 'success',
        serverRevision: editRevision,
      }),
    );
  };

  const onError = () => {
    dispatch(
      depreciationSettingsMutationComplete({
        status: 'error',
      }),
    );
  };

  const mutate = () => {
    depreciationSettingsMutate(
      {
        pathParams: { orderID },
        body: ORDER_DEPRECIATION_SETTINGS_V2_API.PUT.REQUEST.BODY.parse(depreciationSettings),
        queryParams: TKV2_ORDER_DEPRECIATION_SETTINGS_API.PUT.REQUEST.QUERY_PARAMS.parse({
          saveAsDefault: saveAsDefault?.toString(),
        }),
      },
      { onSuccess, onError },
    );
  };

  const mutationTrigger = useEdgeTrigger({
    condition: editRevision > serverRevision,
    delayMs: DEFAULT_SYNC_DRIVER_DELAY_MS,
    action: mutate,
  });

  useEffect(() => {
    mutationTrigger.restartTimer();
  }, [editRevision, mutationTrigger]);
}
